import productImg from '../main/product/productImg';
import productPurchase from '../main/product/productPurchase';
import {
  logisticsAsset,
  manufacturingAsset,
  manufacturingProcess,
  officeAsset,
  retailExhibition,
} from '@pages/Enterprise/Solution/components/Banner/BannerImages';
import video from '@src/assets/images/solution/manufacturingProcess/video/rtlsVideo.mp4';

export default {
  desc: 'Các nhà sản xuất hiện đại đang rất quan tâm đến các giải pháp xây dựng nhà máy thông minh và tự động hóa sản xuất nhằm đảm bảo năng lực cạnh tranh và nâng cao năng suất.',
  keywords:
    'Nhà máy thông minh, tự động hóa sản xuất, giám sát quy trình, nhà máy thông minh, Nha may thong minh, tu dong hoa san xuat, giam sat quy trinh, nha may thong minh.',
  ogSite: 'Giải pháp cho nhà máy thông minh và tự động hóa sản xuất',
  title: 'Giải pháp cho nhà máy thông minh và tự động hóa sản xuất',
  ogUrl: 'https://orbro.io/vi/blog/productionAutomation',
  ogImg:
    'https://lh3.googleusercontent.com/fife/AK0iWDxXE6MzArHBPAtgIpznMDdCH4J8pK06Pt6RC09sNHW7PTLIF0PmPta2ymrlAdxzXB1xM2c15BXwtMiUlMiXHV5-rX_y-MCj5rxn28ZcepfxYkwYGbTtkD2tiwtidfaA7UEiWPc_QZU5UvVQ_07DIs56mvdkD5LITBtqiZP7tZHrG0NN30d5aoj0cErsx5-AXHIQuv5zO6bwkV_42KLIq2YCCSe_xQfkSXyh6zwheUsNCyZV5Cs9oUd6ImOHrCWsB1JXDQljN2q2G8-li2gz1NQV2v7__j_4t3KgJDoCmqWuuFG495xjseOwBNsdbOkL9jBB79LwHj2EeEfqTUCmPYuKjA1HxHrHCe1kQDTXbjBxYc-GoornZ3F1PG1fmwyz5EQt9n7BVSD2smPwW9zHqSVYdcwpwdzjgnVBZ3tKehLBz7gRUtfjRxxmYWMbP6-WvApgEY0_TXrwuOnT_3R44fYEsAQeQSJU1xGt-FT7Kbs_cEtrKJ09pqHvl4tOeWBKTBgqNPQi6jC3AU8eKzNgSPVI641s3fQ9Bgfpq8FFw6Rt4ry87oCoCXJErzzb8G6TI-DWbBnvd0s49QfnIWK2e6fLVdGmnzgy4vMgGa8kwu4YUXRDNn4lju7F-Uwglr1KkkLrfsUgBJe-eLigJnmV32eHXFTRod_bwAstvo2SUiqPG-jwDDjG2mEyQlODDkYR9ghqohTDwpQWEen7XYXcAzlcuo-W2XT-KLvL_3K0LaSWaV9RfuH4lEvJZg_5O4AZVvbaoonwP8c3O2kPDidXj-aGYpEkZAiERMu_6E3LuqbK6LYx3XKDOKkv_BB5569dm6PjLKrCNvyKpsQHYuRzAD6KjmMC2M55q_b4QrIldAJ3OIGc3it9CKfkRPBchL0fmymgKDrP4bYSRskJ7ezbG3mrJlmftUW4zRbdV51Be_JnMCpDP7ZHni4RsYAeKni05hHJmQlYGqb3kj64d5eiJwctbRLV1PRD_TN5cT_1IILP4xyTKxXanxncYJeyv_1ju9rI5-ROwlCt_yt6IDKC6svINvZQGxFd27XpmvlkiFq2KNNTbKekQ7YI9QP9Wssadz30lALiW08lksJZ35fwt2xP_-Wsi6PcMQz-P3uXI_70uAZdl2X5Qe1NEjfoVSUv3r9e8L7Kq22Xo1x7MClBLI1lb88GAe4GaKiYNmhYL1A3YP-hn22TIwRvcJuFHOWWQa1GuowDDCu5xve-5jEasGKyBgkoliyCv4Whu5WYvSKb5uBwYRzJWXr4AuyUGPGTZwcO_067lWFWNoJz9s6XviIJ8aHA7_zJn5ZQrokTVhOC-Cv8m6SM8YfA0bKWlE4hUZjbYdzQDsCl95UzT9WaGLONhe7h7EUo3Nt_oIXYtUso9Lqo6fu8nvLxskCelBaZ5xLRDKYnrYpxehQPCO-iTxz9WGYxKbrTFeHIXJU4jwKn-Envs1kbg34tE5lnMSGW9mGEJLIsO8h7yJ2VrKeks-V2StiHHhLCtQvCZEKJIwLfeQ8wnOuTHDHNAnkuQDSTk6mGn7bOFAOHw7L0Aloc1_6w_HfzWqtEyxlm_9bWDuQyLv9LXHa1=w2000-h1548',
  ogType: 'website',
  date: '2023-11-06',
  tag1: '#Nhamaythongminh',
  tag2: '#Tudonghoasanxuat',
  tag3: '#Giamsatquytrinh',
  tag4: '#Nhamaythongminh',
  text: [
    {
      head: '',
      subHead: '',
      desc: 'Các nhà sản xuất hiện đại đang rất quan tâm đến các giải pháp xây dựng nhà máy thông minh và tự động hóa sản xuất nhằm đảm bảo năng lực cạnh tranh và nâng cao năng suất. Xu hướng này ngày càng trở nên quan trọng hơn với sự phát triển của công nghệ hiện đại và sự lan tỏa của các hệ thống thông minh, trong đó công nghệ Hệ thống Định vị Thời gian Thực (RTLS - Real-Time Location System) đã trở thành một trong những công nghệ cốt lõi để xây dựng nhà máy thông minh.',
      dot: '',
    },
    {
      head: 'Nhà máy thông minh là gì?',
      subHead: '',
      desc: 'Nhà máy thông minh là môi trường sản xuất sử dụng công nghệ tiên tiến nhất và hệ thống tự động hóa với mục đích cải tiến một cách đột phá các hệ thống sản xuất hiện có và tối ưu hóa quy trình sản xuất. Nhà máy thông minh mang lại nhiều lợi ích đa dạng cho nhà sản xuất, qua đó có thể nâng cao chất lượng, tăng năng suất, cải thiện hiệu quả sử dụng năng lượng, v.v. Để hiện thực hóa những lợi ích này, công nghệ RTLS đóng một vai trò then chốt.',
      dot: '',
    },
    {
      head: 'Nhà máy thông minh và công nghệ RTLS',
      subHead: '',
      desc: 'Công nghệ RTLS là viết tắt của Hệ thống Định vị Thời gian Thực, một công nghệ theo dõi chính xác thông tin vị trí của vật thể, thiết bị, sản phẩm, công nhân, v.v., bằng cách sử dụng các công nghệ và cảm biến đa dạng. Khi áp dụng công nghệ này vào nhà máy thông minh, có thể thu được những lợi ích sau:',
      dot: '',
    },
    {
      head: '',
      subHead: 'Quản lý và tối ưu hóa tài nguyên',
      desc: 'Sử dụng RTLS cho phép nắm bắt thông tin vị trí thời gian thực của tất cả các tài nguyên trong cơ sở sản xuất. Qua đó, có thể quản lý và tối ưu hóa hiệu quả thiết bị, vật tư, nhân công, v.v.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Giám sát quy trình sản xuất',
      desc: 'RTLS cho phép giám sát quy trình sản xuất theo thời gian thực. Có thể nhanh chóng phát hiện và ứng phó với các hiện tượng bất thường xảy ra trên dây chuyền sản xuất.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Tự động hóa và ứng dụng robot',
      desc: 'Có thể sử dụng RTLS để điều khiển robot và thiết bị tự động hóa. Nhờ đó, có thể tự động hóa quy trình sản xuất và giảm thiểu sự tham gia của nhân lực.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Quản lý hàng tồn kho',
      desc: 'Có thể quản lý hàng tồn kho và theo dõi sự di chuyển của hàng tồn kho dựa trên thông tin vị trí thời gian thực. Qua đó, giúp giảm chi phí tồn kho và quản lý hàng tồn kho hiệu quả.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Tăng cường an toàn và an ninh',
      desc: 'RTLS có thể tăng cường an toàn và an ninh trong nhà xưởng bằng cách theo dõi vị trí của công nhân. Có thể phát hiện sự xâm nhập trái phép của người không có thẩm quyền và hỗ trợ phòng ngừa tai nạn.',
      dot: '',
    },
    {
      head: 'Phương pháp xây dựng nhà máy thông minh',
      subHead: '',
      desc: 'Để áp dụng RTLS vào nhà máy thông minh, có thể thực hiện theo các bước sau',
      dot: '',
    },
    {
      head: '',
      subHead: 'Phân tích yêu cầu',
      desc: 'Trước tiên, phân tích yêu cầu của nhà sản xuất và quyết định hệ thống RTLS nào là cần thiết.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Lắp đặt cảm biến và phần cứng',
      desc: 'Lắp đặt các cảm biến và phần cứng cần thiết để xây dựng hệ thống RTLS. Chúng được sử dụng để theo dõi vị trí của vật thể và công nhân.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Thu thập và xử lý dữ liệu',
      desc: 'Xử lý dữ liệu do cảm biến thu thập và tạo ra thông tin vị trí thời gian thực.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Tích hợp hệ thống',
      desc: 'Tích hợp hệ thống RTLS với các hệ thống sản xuất khác để ứng dụng vào tự động hóa và giám sát.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Tối ưu hóa và cải tiến',
      desc: 'Khi hệ thống đi vào hoạt động, liên tục thực hiện các công việc cải tiến để giám sát và tối ưu hóa quy trình sản xuất.',
      dot: '',
    },
    {
      head: 'Tương lai của tự động hóa sản xuất và nhà máy thông minh',
      subHead: '',
      desc: 'Nhà máy thông minh được xây dựng xoay quanh RTLS được kỳ vọng sẽ đóng vai trò dẫn dắt ngành sản xuất trong tương lai. Tự động hóa sản xuất và các hệ thống thông minh đóng vai trò quan trọng trong việc nâng cao chất lượng và năng suất. Hơn nữa, thông qua việc tích hợp với Trí tuệ nhân tạo (AI) và phân tích Dữ liệu lớn (Big Data), việc vận hành nhà máy sẽ trở nên thông minh và hiệu quả hơn nữa.\nGiải pháp xây dựng nhà máy thông minh và tự động hóa sản xuất là những bước đi thiết yếu để các nhà sản xuất hiện đại tăng cường năng lực cạnh tranh và đạt được tăng trưởng bền vững. Công nghệ RTLS hỗ trợ những nỗ lực hướng tới tương lai này và đang đóng góp vào việc xây dựng một môi trường sản xuất đổi mới. Các nhà sản xuất cần tích cực áp dụng những công nghệ này và tiếp tục nỗ lực để xây dựng thành công nhà máy thông minh.',
      dot: '',
    },
  ],

  link: {
    page: 'rtls',
    numb: '2',
    product: [
      {
        text: productPurchase.purchase.ble.bleStarterKit.title,
        title: productPurchase.purchase.ble.bleStarterKit.title,
        serial: productPurchase.purchase.ble.bleStarterKit.serial,
        desc: 'Sản phẩm này giúp gắn thiết bị UWB lên nhân viên hoặc thiết bị, hỗ trợ theo dõi vị trí theo thời gian thực.',
        img: productImg.product.bleStarterKit.thumbnail,
      },
      {},
    ],
    solution: [
      {
        img: manufacturingProcess.thumb,
        data: 'manufacturingProcess',
        link: '/vi/enterprise/manufacturing/process',
      },
      {
        img: manufacturingAsset.thumb,
        data: 'manufacturingAsset',
        link: '/vi/enterprise/manufacturing/asset',
      },
      {
        img: logisticsAsset.thumb,
        data: 'logisticsAsset',
        link: '/vi/enterprise/logistics/asset',
      },
    ],
  },
};
